import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function PayIn({ children }) {
  useInjectSaga({ key: 'settingsPayIn', saga });
  useInjectReducer({ key: 'settingsPayIn', reducer });

  return React.Children.only(children);
}

PayIn.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withSettingsPayIn } from './withSettingsPayIn';
export default compose(withConnect, memo)(PayIn);
